import React from 'react';
import { Spinner } from 'react-bootstrap';

import Button from 'components/DesignSystem/Button';
import Icon from 'components/DesignSystem/Icon';
import { WindxPreferencia } from 'helper/windx';
import { cssVar } from 'constants/theme';

interface ListaProps {
  prefs: WindxPreferencia[];
  isLoadingList: boolean;
  isDeleting: boolean;
  onRestore: (pref: WindxPreferencia) => void;
  onDelete: (id: number) => void;
}

/**
 * Corpo da lista de Preferencias Salvas — sem casca.
 *
 * O desktop envolve com `Accordion.Body` e o mobile com o `Section` do
 * BottomSheet. Mantido presentacional de proposito: o estado e as regras
 * vivem em `useSavedPreferences`, chamado uma vez por painel.
 */
export default function Lista({
  prefs, isLoadingList, isDeleting, onRestore, onDelete,
}: ListaProps) {
  return (
    <>
      {isLoadingList && (
        <div className="text-center py-2">
          <Spinner animation="border" size="sm" role="status" aria-label="Carregando preferências" />
        </div>
      )}

      {!isLoadingList && prefs.length === 0 && (
        <p className="text-muted small mb-0">
          Nenhuma preferência salva para esta tela.
        </p>
      )}

      {prefs.map((pref) => (
        <div key={pref.id} className="d-flex align-items-center">
          <Button
            type="tertiary"
            className="btn-control-panel flex-grow-1 text-start"
            onClick={() => onRestore(pref)}
          >
            {pref.nome}
          </Button>
          <Button
            type="tertiary"
            className="btn-preference p-1"
            disabled={isDeleting}
            onClick={() => onDelete(pref.id)}
          >
            {isDeleting
              ? <Spinner size="sm" aria-hidden="true" />
              : <Icon iconType="trash" color={cssVar('text-accent')} />}
          </Button>
        </div>
      ))}
    </>
  );
}
